import { createSlice } from '@reduxjs/toolkit'

export const workdirSlice = createSlice({
	name: 'workdir',
	initialState: {
		value: { entity: {}, files: [], entityType: '' },
	},
	reducers: {
		setEntity: (state, action) => {
			state.value.entity = action.payload
		},
		setFiles: (state, action) => {
			state.value.files = action.payload
		},
		setEntityType: (state, action) => {
			state.value.entityType = action.payload
		},
	},
})

// thunk that accepts either an array or an updater function
export const updateFiles = (updaterOrArray) => (dispatch, getState) => {
	const current = getState().workdir.value.files
	const next =
		typeof updaterOrArray === 'function'
			? updaterOrArray(current)
			: updaterOrArray
	dispatch(setFiles(next))
}

export const { setEntity, setFiles, setEntityType } = workdirSlice.actions

export default workdirSlice.reducer
